import React from 'react';

class ApplicationError extends React.Component {
    constructor(props: any) {
        super(props);
    }

    render() {
        return (
            <div>
                <div className="header">
                    <div className="header-nav">
                        <div className="text-center text-uppercase brand">
                            BRAVO GENERAL INSURANCE SERVICES
                    </div>
                    </div>
                </div>

                <div className="error-container">
                    <div className="card">
                        <div className="card-body">
                            <div className="titleArea"><h5>Application Error!</h5></div>
                            <p className="text-uppercase">We’re experiencing a technical problem on our side, sorry about that.</p>
                            <p className="text-uppercase">Please contact our Customer Service Center and we’ll be happy to assist you with completing the purchase of your policy.</p>
                            <h5 className="text-uppercase font-weight-bold">(888)381-8050</h5>
                            <div>&nbsp;</div>
                            <p><a href="/d2c" className="font-weight-bold"><i className="fas fa-chevron-left"></i> Home</a></p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ApplicationError;

